import _ from 'lodash'
import viewName from '../constant.js'

import {
    getClassification
} from '@/models/goodsClassification'
export default {
    name: viewName.goodsClassification,
    inject: ['showLoading', 'hideLoading'],
    data () {
        return {
            catelogOne: [{
                cate_id: '',
                cate_name: '全部',
                parent_id: '',
                children: [{
                    cate_id: '',
                    cate_name: '全部',
                    parent_id: '',
                    children: [{
                        cate_id: '',
                        cate_name: '全部',
                        parent_id: ''
                    }]
                }]
            }],
            cate_id: '',
            catelogTwo:[],
            activeCate: ''
        }
    },
    created () {
        this.getClassification()
    },
    methods: {
        async getClassification () {
            this.showLoading()
            const res = await getClassification()
            this.hideLoading()
            this.catelogOne = this.catelogOne.concat(res)
            if (this.$route.query.activeCate) {
                this.cate_id = this.$route.query.cate_id || ''
                this.activeCate = this.$route.query.activeCate
                const index = _.findIndex(this.catelogOne, (item) => item.cate_name === this.activeCate)
                this.catelogTwo = this.catelogOne[index].children
                return
            }
            this.activeCate =  this.catelogOne[0].cate_name
            this.catelogTwo = this.catelogOne[0].children
        },
        changeCate (item) {
            this.activeCate = item.cate_name
            this.catelogTwo = item.children
        }
    },
}
